import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  isLoading: false,
  courseResponse: "",
  courses: [],
  selectedCourse: {},
}

const enrolSlice = createSlice({
  name: "course",
  initialState,
  reducers: {
    isPending: (state) => {
      state.isLoading = true
    },
    getCoursesSuccess: (state, { payload }) => {
      state.isLoading = false
      state.courses = payload || {}
    },
    getSingleCourseSuccess: (state, { payload }) => {
      state.isLoading = false
      state.selectedCourse = payload || {}
    },
    getCoursesFail: (state, { payload }) => {
      state.isLoading = false
      state.courseResponse = payload
    },
  },
})

const { reducer, actions } = enrolSlice

export const {
  getCoursesSuccess,
  getSingleCourseSuccess,
  isPending,
  getCoursesFail,
} = actions

export default reducer
